const MINUTE_MS = 60_000;
const STUNDE_MS = 60 * MINUTE_MS;
const TAG_MS = 24 * STUNDE_MS;

const RELATIV = new Intl.RelativeTimeFormat("de", { numeric: "auto" });
const DATUM = new Intl.DateTimeFormat("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });

/**
 * Relative deutsche Beschreibung eines Zeitpunkts ("vor 5 Minuten", "gestern").
 * Ab einer Woche wird auf ein festes Datum umgestellt — "vor 41 Tagen" liest sich
 * ab dort schlechter als ein Kalenderdatum.
 */
export function relativeZeit(iso: string, jetzt: Date = new Date()): string {
  const zeitpunkt = new Date(iso);
  const differenzMs = zeitpunkt.getTime() - jetzt.getTime();
  const absMs = Math.abs(differenzMs);

  if (absMs < MINUTE_MS) return "gerade eben";
  if (absMs < STUNDE_MS) return RELATIV.format(Math.round(differenzMs / MINUTE_MS), "minute");
  if (absMs < TAG_MS) return RELATIV.format(Math.round(differenzMs / STUNDE_MS), "hour");
  if (absMs < 7 * TAG_MS) return RELATIV.format(Math.round(differenzMs / TAG_MS), "day");
  return formatDatum(iso);
}

/** Reiner Kalendertag ohne Uhrzeit, wie ihn eine DATE-Spalte liefert ("Kunde seit"). */
const NUR_DATUM = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * Festes Datum im deutschen Format, z. B. für "Kunde seit".
 *
 * Ein reiner Kalendertag trägt weder Uhrzeit noch Zone. new Date("2024-01-01") liest ihn
 * nach ECMA-262 als UTC-Mitternacht — westlich von Greenwich stünde damit der Vortag auf
 * dem Bildschirm. Deshalb wird er als örtlicher Kalendertag zusammengesetzt; echte
 * Zeitpunkte (ISO-8601 mit "Z", so wie die API sie liefert) laufen unverändert weiter.
 */
export function formatDatum(iso: string): string {
  const teile = NUR_DATUM.exec(iso);
  if (teile !== null) {
    return DATUM.format(
      new Date(Number(teile[1]), Number(teile[2]) - 1, Number(teile[3])));
  }
  return DATUM.format(new Date(iso));
}
